<template>
    <nav v-if="role == 'booster'">                    
        <v-rating
            :value=0
            :length=question.allowed_options
            align="center"
            class="survey-rating"
            readonly
            data-testid="rating-numbers"
        >
            <template v-slot:item="props">
                <v-icon
                    :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
                    :color="props.isFilled ? 'accent' : ''"
                    v-text="`mdi-numeric-${props.index + 1}`"
                    @click="props.click"
                    large
                ></v-icon>
            </template>
        </v-rating>
        <v-col cols="12" :md="preview || screen == 'mobile-view' ? '12' : '7'" class="mx-auto px-0">
            <v-textarea dense outlined disabled class="survey-rating-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto" :placeholder="$t('surveyTextareaParticipantPlaceholder')" data-testid="rating-textarea" />
        </v-col>
    </nav>
    <nav v-else>
        <v-rating
            v-model=rating
            :length=question.allowed_options
            align="center"
            class="survey-rating"
            data-testid="rating-numbers"
            @input="answerQuestion()"
        >
            <template v-slot:item="props">
                <v-icon
                    :class="props.isFilled ? 'rating-filled' : 'rating-notfilled'"
                    :color="props.isFilled ? 'accent' : ''"
                    v-text="`mdi-numeric-${props.index + 1}`"
                    @click="props.click"
                    large
                ></v-icon>
            </template>
        </v-rating>
        <v-col cols="12" md="7" class="mx-auto">
            <v-textarea v-model="answer" dense outlined class="survey-rating-textarea rounded-lg pa-0 ma-0 mt-3 text-body-2 mx-auto" data-testid="rating-textarea" @change="answerQuestion"/>
        <p v-if="showError" class="error--text font-italic pt-3">{{ $t('answerError') }}</p>
        </v-col>
        
    </nav>
</template>
<script>
export default {
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    role: {
      type: String,
      default: 'booster'
    },
    invalidAnswers: {
      type: Array,
      default: () => []
    },
    hasSubmittedSurvey:{
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    },
    screen: {
      type: String,
      default: ''
    }
  },
  data(){
    return{
      rating: 0,
      answer: '',
      answerObject: {
        type: this.question.type,
        id: this.question.id,
        rating: 0,
        answer: ''
      },
      showError: false
    }
  },
  created(){
    //check if question was already submitted
    // const found = this.answers.find(object => object.id  == this.question.id);
    // if(found){
    //   this.answerObject = found
    // }
    this.$emit('sendAnswer', this.answerObject)
  },
  watch: {
    invalidAnswers() {
      this.showError = false
      if (this.hasSubmittedSurvey && this.invalidAnswers.includes(this.question.id)) {
        this.showError = true
      }
    },
  },
  methods: {
    answerQuestion(){
      this.answerObject.rating = this.rating
      this.answerObject.answer = this.answer
      this.$emit('sendAnswer', this.answerObject)
    }
  }
}
</script>